var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isVisible)?_c('span',{class:_vm.classObject},[_vm._v(" "+_vm._s(_vm.title)+" "+_vm._s(_vm.description)+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }